import { Row, RowProps } from 'antd';
import React from 'react';
import KickImage from 'Reuseables/KickImage';
import Styles from './Grid.module.scss';
import 'antd/es/row/style/css';
type TGridProps = RowProps;

const Grid: React.FC<TGridProps> = ({ children, ...props }) => {
  return <Row {...props}>{children}</Row>;
};

export default Grid;
